import { Box, getThemeColor, ThemeColors } from '@fairfashion/design-system'
import { styled } from 'styled-components'

export const IconContainer = styled(Box)<{ color: ThemeColors }>`
  width: 44px;
  height: 44px;
  border-radius: 10px;
  align-items: center;

  background-color: ${({ color, theme }) => getThemeColor(color, theme)};
  box-shadow: 1px 2px 4px 0px rgba(0, 0, 0, 0.16);
  justify-content: center;
`
